<template>
  <div class="happysocks">
    <section class="container section-1">
      <img
        class="client-logo"
        src="/static/images/cases/happysocks/logo.svg"
        alt="HappySocks"
      />
      <div class="title">
        <h1>
          Happiness Everywhere
        </h1>
        <p>
          Bringing happiness and color to every corner of the world since 2008.
        </p>
      </div>
      <img
        class="big"
        src="/static/images/cases/happysocks/happysocks_top_image.png"
        srcset="/static/images/cases/happysocks/happysocks_top_image2x.png 2x"
        alt="ipad screenshot"
      />
    </section>
    <section class="container section-2">
      <img
        class="big"
        src="/static/images/cases/happysocks/happysocks_magento_image2x.png"
        srcset="
          /static/images/cases/happysocks/happysocks_magento_image2x.png 2x
        "
        v-scroll-reveal="{
          delay: 0,
          distance: '1000px',
          duration: 2000,
          origin: 'bottom'
        }"
        alt="ipads screenshots"
      />
      <div
        class="quarter"
        v-scroll-reveal="{ delay: 200, distance: '1000px', origin: 'right' }"
      >
        <h2>Pushing Magento to its limits</h2>
        <p>
          Bypassing the bottlenecks and going straight for the database, using
          express.js for a near-instant experience.
        </p>
      </div>
    </section>
    <section class="container section-3">
      <div class="third center" v-scroll-reveal="{ delay: 200 }">
        <img src="/static/images/icons/rocket.svg" alt="" />
        <h3>From Snoop Dogg to The Beatles</h3>
        <p>
          Enabling creatives to build custom campaigns without the need of a
          developer. Right on the page, in real-time.
        </p>
      </div>
      <div class="third center" v-scroll-reveal="{ delay: 400 }">
        <img src="/static/images/icons/phone.svg" alt="" />
        <h3>A faster and better mobile experience</h3>
        <p>
          A decluttered UI with sprinkled happiness on top.
        </p>
      </div>
      <div class="third center" v-scroll-reveal="{ delay: 600 }">
        <img src="/static/images/icons/flags.svg" alt="" />
        <h3>90 countries and counting</h3>
        <p>
          With a presence in over 10 000 stores all over the world, from LA to
          Tokyo, Happy Socks is a true global brand.
        </p>
      </div>
    </section>

    <section class="container section-5">
      <div
        class="half center"
        v-scroll-reveal="{ delay: 200, distance: '1000px', origin: 'right' }"
        style="margin-bottom: 3em;"
      >
        <h2>AI merchandising</h2>
        <p>
          Leveraging AI for better search and automatic merchandising based on
          user interaction for increased conversion.
        </p>
      </div>
      <VideoHolder
        v-scroll-reveal="{
          delay: 0,
          distance: '1000px',
          duration: 2000,
          origin: 'bottom'
        }"
        source-mobile="https://player.vimeo.com/external/417642064.m3u8?s=1addbe5cbca44e936721251f49cf014f4342a9f2"
        source-desktop="https://player.vimeo.com/external/417990815.m3u8?s=cd2fac1e67187eee50f20a10b585389417581438"
        design="b"
      />
    </section>
    <section class="next-project">
      <router-link to="/cases/asket">
        View next case →
      </router-link>
    </section>
    <StartProject />
    <Footer />
  </div>
</template>

<script>
import StartProject from "@/components/home/StartProject.vue";
import Footer from "@/components/Footer.vue";
import VideoHolder from "@/components/general/VideoHolder";

export default {
  name: "HappySocks",
  components: {
    VideoHolder,
    StartProject,
    Footer
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.happysocks {
  max-width: 100vw;
  overflow-x: hidden;
  section {
    min-height: 100vh;
    display: flex;
    align-items: center;

    h2 {
      @include headline-medium;
    }
    p {
      //opacity: 0.7;
    }
  }
  .section-1 {
    .title {
      position: sticky;
      top: 10vh;
      left: 5.3vw;
      width: 30vw;
      z-index: 2;
      h1 {
        @include headline-large;
        font-weight: 400;
      }
    }
    img.big {
      position: absolute;
      right: 13vw;
      top: -180px;
      z-index: 1;
    }
    .client-logo {
      position: fixed;
      right: 5.3vw;
      bottom: 5vh;
      width: 5vw;
      z-index: 2;
    }
  }
  .section-2 {
    //justify-content: center;
  }
  .section-3 {
    h3 {
      @include headline-small;
    }
    .third {
      text-align: center;
      img {
        height: 10vh;
        margin-bottom: 10vh;
        //opacity: 0.5;
      }
    }
  }
  .section-4 {
    display: none;
    justify-content: center;
    background: $black;
    img {
      display: inline-block;
      max-width: 50%;
      box-shadow: 5vw 5vh 100px rgba(black, 0.2);
      &:nth-child(2) {
        margin-top: 50vh;
      }
    }
  }
  .section-5 {
    flex-direction: column;
    justify-content: center;
    .half {
      text-align: center;
      padding-right: 0;
      padding-left: 0;
    }
  }
  .next-project {
    min-height: 20vh;
    justify-content: center;
    align-items: center;
    //border-bottom:1px solid rgba(white,0.1);
    a {
      @include headline-small;
    }
  }

  .project {
    display: flex;
    > div {
      flex: 0 0 50%;
      max-width: 444px;
    }
    .left {
      margin-top: -190px;
    }
  }
}
@media (max-width: $tablet) {
  .happysocks {
    section {
      width: 100vw;
      overflow: hidden;
    }
    .section-1 {
      img.big {
        right: 0;
        top: -180px;
      }
    }
    .section-2 {
      margin-top: 220px;
    }
  }
}
@media (max-width: $mobile) {
  .happysocks {
    section {
      min-height: 100vh;
      display: block;
    }
    .section-1,
    .section-2,
    .section-3,
    .section-4,
    .section-5 {
      img.big {
        position: relative;
        max-width: 100vw;
        margin: 0 -30px;
        height: 700px;
        object-fit: cover;
        right: 0;
      }
    }
    .section-1 {
      .title {
        position: relative;
        top: 0;
        left: 0;
        text-align: center;
        width: 100%;
        padding: 50px 30px;
      }
      img.big {
        top: -10px;
      }
      .client-logo {
        width: 15vw;
      }
    }
    .section-2 {
      display: block;
      text-align: center;
      margin-top: unset;
      padding-top: 5vh;
      img.big {
        height: 500px;
      }
      .quarter {
        width: 100%;
        padding-right: 0;
      }
    }
    .section-3 {
      .third {
        width: 100%;
        margin-bottom: 100px;
      }
    }
    .section-4 {
      display: none;
    }
    .section-5 {
      .half {
        width: 100%;
      }
      img.big {
        height: 300px;
      }
    }
    .next-project {
      text-align: center;
    }
  }
}
</style>
